import React from 'react'
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap'
import { buildPropTypes, pt } from 'common-data/proptypehelpers'
import _ from 'common-tools/LodashHelper'
import styles from './TabBox.less'

export class TabBoxItem extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    children: pt.any,
    title: pt.string.isRequired,
    tabId: pt.string.isRequired
  })

  static defaultProps = {
    title: 'Some Tab'
  }

  render () {
    const { children } = this.props
    return children
  }
}

export class TabBox extends React.Component {
  constructor (props) {
    super(props)

    const { defaultTabId } = props
    this.state = {
      activeTab: defaultTabId
    }
  }

  static propTypes = buildPropTypes([

  ], {
    children: pt.oneOfType([pt.arrayOf(pt.element), pt.element]),
    defaultTabId: pt.string.isRequired
  })

  static defaultProps = {
    defaultTabId: '1'
  }

  toggle (tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      })
    }
  }

  getItems (items) {
    const ret = {
      navs: [],
      tabs: []
    }
    const { activeTab } = this.state
    if (_.isArray(items)) {
      _.forEach(items, (item, i) => {
        if (item) {
          if (item.type === TabBoxItem) {
            ret.navs.push(<NavItem key={item.props.tabId}>
              <NavLink
                className={activeTab === item.props.tabId ? 'active' : ''}
                onClick={() => { this.toggle(item.props.tabId) }}
              >
                {item.props.title}
              </NavLink>
            </NavItem>)
            ret.tabs.push(<TabPane key={item.props.tabId} tabId={item.props.tabId}>
              {item.props.children}
            </TabPane>)
          }
        }
      })
    }
    return ret
  }

  render () {
    const { children } = this.props
    const items = this.getItems(children)

    return (
      <div className={styles.root}>
        <Nav tabs>
          {items.navs}
        </Nav>
        <TabContent activeTab={this.state.activeTab}>
          {items.tabs}
        </TabContent>
      </div>
    )
  }
}
